import { render, staticRenderFns } from "./FileAttachments.vue?vue&type=template&id=23d71313&"
import script from "./FileAttachments.vue?vue&type=script&lang=js&"
export * from "./FileAttachments.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachments.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports